import { useContext } from "react"
import CatalogBrowserContext from "./CatalogBrowserContext"
import ThemableButton from "../Items/ThemableButton"
import { faRocket, faXmark } from "@fortawesome/pro-solid-svg-icons"
import { Space } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { green } from "@ant-design/colors"

type Props = {
  disabled?: boolean
}

const ToggleCatalogBrowserButton = ({disabled}: Props) => {
  const {isCatalogBrowserOpen, toggleCatalogBrowser} = useContext(CatalogBrowserContext)
  const icon = isCatalogBrowserOpen ? faXmark : faRocket
  const color = isCatalogBrowserOpen ? green[7] : green[6]

  return <ThemableButton colorPrimary={color} type="primary" size="large" onClick={toggleCatalogBrowser} disabled={disabled}>
    <Space>
      <FontAwesomeIcon icon={icon} />
      {isCatalogBrowserOpen ? 'Close Catalog Browser' : 'Open Catalog Browser'}
    </Space>
  </ThemableButton>
}

export default ToggleCatalogBrowserButton